// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3g-I_","buttons":"SendReceipts_buttons__21Nul","email":"SendReceipts_email__2Acfy","bookApptTitle":"SendReceipts_bookApptTitle__3k3FS"};